import React from 'react';

const SvgEu = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="EU_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="EU_svg__b" fill="#fff">
        <use xlinkHref="#EU_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#EU_svg__a" />
      <path fill="#043CAE" mask="url(#EU_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M14 4l-.943.276.276-.943-.276-.942.943.276.943-.276-.276.942.276.943L14 4zm0 13.333l-.943.276.276-.942-.276-.943L14 16l.943-.276-.276.943.276.942-.943-.276zm6.667-6.666l-.943.276L20 10l-.276-.943.943.276.942-.276-.276.943.276.943-.942-.276zm-13.334 0l-.942.276.276-.943-.276-.943.942.276.943-.276L8 10l.276.943-.943-.276zm12.44-3.334l-.942.276.276-.942-.276-.943.943.276.942-.276-.276.943.276.942-.942-.276zM8.227 14l-.942.276.276-.943-.276-.942.942.276.943-.276-.276.942.276.943L8.226 14zm9.107-9.107l-.942.276.276-.943-.276-.942.942.276.943-.276-.276.942.276.943-.943-.276zM10.667 16.44l-.943.276.276-.942-.276-.943.943.276.942-.276-.276.943.276.942-.942-.276zM19.774 14l-.943.276.276-.943-.276-.942.943.276.942-.276-.276.942.276.943-.942-.276zM8.226 7.333l-.942.276.276-.942-.276-.943.942.276.943-.276-.276.943.276.942-.943-.276zm9.107 9.107l-.942.276.276-.942-.276-.943.942.276.943-.276-.276.943.276.942-.943-.276zM10.667 4.893l-.943.276.276-.943-.276-.942.943.276.942-.276-.276.942.276.943-.942-.276z"
        fill="#FFD429"
        mask="url(#EU_svg__b)"
      />
    </g>
  </svg>
);

export default SvgEu;
